import { FC, ReactNode } from 'react';

import { StyledCell } from '../Grid';
import type { MostViewedResearchItem } from '../model';
import { ResearchItem } from './ResearchItem';

interface PopularResearchProps {
  data: ReadonlyArray<MostViewedResearchItem>;
  className?: string;
}

type GridProps = PopularResearchProps &
  Readonly<{
    render: (item: MostViewedResearchItem) => ReactNode;
  }>;
export const PopularResearchGrid: FC<GridProps> = ({ data, className, render }) => (
  <>
    {data.map((item, idx) => (
      <StyledCell key={`${item.sourceId}.${idx}`} $rowIndex={idx} className={className}>
        {render(item)}
      </StyledCell>
    ))}
  </>
);

export const PopularResearch: FC<PopularResearchProps> = ({ data, className }) => (
  <PopularResearchGrid
    data={data}
    className={className}
    render={({ title, date, link, sourceId, author, viewedCount }) => (
      <ResearchItem title={title} date={date} link={link} key={sourceId} author={author} countOfReading={viewedCount} />
    )}
  />
);
